import React, { memo } from 'react'
import { Flex, Box, css } from '@alobato/flex-box'
import Text from '@alobato/text'
import useFetch from '@alobato/use-fetch'
import CircularProgress from '@alobato/circular-progress'
import { CloseIcon } from '../../components/Icons'
import Label from '../../components/Label'

import AUTH_TOKEN from '../../constants/authToken'
import BASE_API from '../../constants/baseApi'
import { OPCOES_GENERO, valorDeGenero } from '../../constants/genero'

/* Detalhe do médico.

   Mostrava só ID, nome, e-mail e os dois CRMs — enquanto o cadastro já tinha
   especialidade, valor, planos e clínicas, tudo editável ao lado. Quem abria
   "Detalhes" para conferir se o cadastro estava completo via meia dúzia de
   linhas e concluía que faltava tudo. */

const traco = valor => {
  if (valor === null || valor === undefined) return '—'
  const texto = String(valor).trim()
  return texto || '—'
}

const dataBR = iso => {
  if (!iso) return '—'
  const partes = String(iso).slice(0, 10).split('-')
  if (partes.length !== 3) return '—'
  return `${partes[2]}/${partes[1]}/${partes[0]}`
}

const nomes = lista =>
  Array.isArray(lista) && lista.length ? lista.map(i => i.name).join(', ') : '—'

const Item = ({ label, children }) => (
  <Box mb={3}>
    <Label>{label}</Label>
    <Box>{children}</Box>
  </Box>
)

const Show = memo(({ data, onRequestClose }) => {
  const genero = OPCOES_GENERO.find(o => o.valor === valorDeGenero(data.gender))
  const inscricoes = Array.isArray(data.crms) ? data.crms : []

  return (
    <Flex flexDirection='column' h='100%'>
      <Flex bg='grey100' minHeight={64} ai='center'>
        <Box w={64} />
        <Box flex={1} ta='center' css={css`white-space: nowrap; overflow: hidden; text-overflow: ellipsis;`}>
          <Text medium>Detalhes Médico</Text>
        </Box>
        <Box w={64} lh={0} ta='center'><Box onClick={onRequestClose} d='inline-block' cursor='pointer' p={1}><CloseIcon /></Box></Box>
      </Flex>

      <Box p={4} overflow='auto'>

        {data.thumbnail &&
          <Box mb={3}>
            <img
              src={data.thumbnail}
              alt={data.name || 'Foto do médico'}
              style={{ width: 72, height: 72, borderRadius: '50%', objectFit: 'cover' }}
            />
          </Box>
        }

        <Item label='ID'>{data.id}</Item>
        <Item label='Nome'>{traco(data.name)}</Item>
        <Item label='Email'>{traco(data.login)}</Item>
        <Item label='Celular'>{traco(data.phone)}</Item>
        <Item label='Data de nascimento'>{dataBR(data.birth_date)}</Item>
        <Item label='Gênero'>{genero ? genero.rotulo : '—'}</Item>

        <Item label={inscricoes.length > 1 ? 'Inscrições no Conselho' : 'CRM'}>
          {inscricoes.length === 0 ? '—' : inscricoes.map(c => (
            <Box key={`${c.number}-${c.uf}`}>
              {c.type} {c.number}{c.uf ? ` / ${c.uf}` : ''}
              {!c.primary && ' (secundária)'}
            </Box>
          ))}
        </Item>

        <Item label='Especialidade primária'>{traco(data.specialty_primary_name)}</Item>
        <Item label='Especialidade secundária'>{traco(data.specialty_secondary_name)}</Item>
        <Item label='Valor da consulta'>{data.price ? `R$ ${data.price}` : '—'}</Item>
        <Item label='Descrição'>{traco(data.description)}</Item>
        <Item label='Planos atendidos'>{nomes(data.health_insurances_obj)}</Item>
        <Item label='Clínicas'>{nomes(data.establishments_obj)}</Item>
        <Item label='Aceitou os termos'>{data.accept_terms ? 'Sim' : 'Não'}</Item>
        <Item label='Cadastrado em'>{dataBR(data.created_at)}</Item>

      </Box>
    </Flex>
  )
})

export default memo(props => {
  const { data, error, loading } = useFetch(`${BASE_API}/doctor?id=${props.id}`, { headers: { Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}` } })
  if (error) return `Erro! ${error.message}`
  if (!data || loading) return <CircularProgress color='hsla(199, 75%, 43%, 1)' />
  return <Show {...props} data={data} />
})
